import { z } from 'zod';
export const SendWhatsappRequest = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('text'), message: z.string().min(1).max(4096) }),
    z.object({ kind: z.literal('ticket'), caption: z.string().max(1024).optional() }),
]);
export const SendWhatsappResponse = z.object({
    attendeeId: z.string().uuid(),
    to: z.string(),
    messageId: z.string().nullable(),
    status: z.enum(['sent', 'noop']),
});
export const WhatsappTestRequest = z.object({
    to: z.string().min(1),
    message: z.string().min(1).max(4096),
});
export const WhatsappTestResponse = z.object({
    to: z.string(),
    messageId: z.string().nullable(),
    status: z.enum(['sent', 'noop']),
});
//# sourceMappingURL=whatsapp.js.map